/*******************************************************************************
* Project: J-SIPHE
* Summary:
*    Define FormDate Pipe
* History:
*    NghiaNX            2021/05/09    Create Date format pipe
******************************************************************************/
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'FormDatePipe' })
export class FormDatePipe implements PipeTransform {
    transform(val: any) {
        const regex = /[^0-9\/]/g;
        const value = val.replace(regex, '');
        return value;
    }
}
